import React from "react";

export const VerticalSpace = React.memo(({ size = 8 }) => (
  <div style={{ height: size, flexShrink: 0 }} />
));

export const HorizontalSpace = React.memo(({ size = 8 }) => (
  <div style={{ width: size, flexShrink: 0 }} />
));

export const Divider = React.memo(
  ({ width, height = 1, marginVertical = 0, marginHorizontal = 0 }) => (
    <div
      style={{
        backgroundColor: "var(--grey)",
        width,
        height,
        minHeight: height,
        margin: `${marginVertical}px ${marginHorizontal}px`,
        flexShrink: 0,
      }}
    />
  )
);
